import { useCallback, useState } from "react";
import { Box, IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { DeleteOutline } from "@mui/icons-material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import Text from "../../text/Text";
import {
  callAPIInterface,
  contactPaymentMethods,
  getIcon,
} from "../../constants";
import { addNewAddress, deleteAddress, deleteAddressMsg } from "../../messages";
import WalletSymbols from "../../WalletSymbols";
import CommonDrawer from "../../drawer/CommonDrawer";
import TruncatedTextTooltip from "../../TruncatedTextTooltip";
import DeleteDrawer from "./DeleteDrawer";

function AddressListDrawer({
  openDrawer,
  setOpenDrawer,
  contact,
  setContact,
  setOpenAddDrawer,
  setDisplayedAddress,
}) {
  const navigate = useNavigate();

  const [openDeleteDrawer, setOpenDeleteDrawer] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState(null);

  const handleDelete = async () => {
    try {
      await callAPIInterface(
        "DELETE",
        `/customers/${contact?.id}/payment-addresses/${selectedAddress?.id}`
      );
      const filteredAddress = contact.payment_address_details.filter(
        (address) => address.id !== selectedAddress?.id
      );
      if (!filteredAddress.length) {
        await callAPIInterface("DELETE", `/customers/${contact?.id}`);
        navigate("/settings/contacts");
        return;
      }
      setContact((contact) => {
        return {
          ...contact,
          payment_address_details: filteredAddress,
        };
      });
      setDisplayedAddress((prev) => {
        return prev.id === selectedAddress.id ? filteredAddress[0] : prev;
      });
      setOpenDeleteDrawer(false);
    } catch (error) {
      console.error("Error deleting address", error);
    }
  };

  const renderBody = useCallback(() => {
    return (
      <>
        {contact?.payment_address_details?.map((address) => {
          const { payment_method, target_currency } = address;
          const imageUrl = getIcon(payment_method, target_currency);

          const addressType = contactPaymentMethods.find(
            (method) => method.payment_method === payment_method
          )?.label;

          return (
            <Box
              className="address-list-item"
              onClick={() => {
                setDisplayedAddress(address);
                setOpenDrawer(false);
              }}
            >
              <img src={imageUrl} height={30} width={30} />
              <Box>
                <Text size={16} font="semibold">
                  {addressType}
                </Text>
                <Text
                  size={14}
                  font="regular"
                  className="grey-text payment-address-text"
                  title={address.payment_address}
                >
                  {address.payment_address}
                </Text>
              </Box>
              <IconButton
                disableTouchRipple
                sx={{
                  position: "static !important",
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedAddress(address);
                  setOpenDeleteDrawer(true);
                }}
              >
                <DeleteOutline />
              </IconButton>
            </Box>
          );
        })}
        <Text
          onClick={() => setOpenAddDrawer(true)}
          sx={{
            display: "flex",
            padding: "16px",
            color: "#2A67FF",
            cursor: "pointer",
          }}
        >
          <WalletSymbols symbol="add" sx={{ height: "24px", width: "24px" }} />
          {addNewAddress}
        </Text>
      </>
    );
  }, [contact]);

  return (
    <>
      <CommonDrawer
        className="address-list-drawer"
        open={openDrawer}
        onClose={() => setOpenDrawer(false)}
        anchor="top"
      >
        <Box className="address-list-drawer-content">
          <Box className="drawer-header">
            <ArrowBackIcon
              onClick={() => {
                setOpenDrawer(false);
              }}
            ></ArrowBackIcon>
            <TruncatedTextTooltip
              textProps={{
                className: "default-text",
                font: "semibold",
                maxWidth: "400px",
                width: {
                  xs: "180px",
                  sm: "350px",
                  md: "400px",
                },
              }}
              textValue={contact?.name}
              fontSize={18}
              lineHeight={25}
            />
          </Box>
          <Box className="drawer-content">{renderBody()}</Box>
        </Box>
      </CommonDrawer>
      <DeleteDrawer
        openDrawer={openDeleteDrawer}
        setOpenDrawer={setOpenDeleteDrawer}
        deleteTitle={deleteAddress}
        deleteSubText={deleteAddressMsg}
        handleDelete={handleDelete}
      />
    </>
  );
}

export default AddressListDrawer;
